import CombLoading from './CombLoading';
export default CombLoading;


// WEBPACK FOOTER //
// ./src/components/CombLoading/index.js